exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../css-loader/index.js??ruleSet[1].rules[7].use[1]!./lib/perfect-scrollbar.side.css"), "");

// module
exports.push([module.id, ".DS__styles-side__scrollbar-container {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__styles-side__scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"scrollbar-container": "DS__styles-side__scrollbar-container"
};